import { isNotEmpty } from '@lhb/func';
import { XTCLabel } from '@/views/youth/pages/map/ts-config';

/**
 * 相似商圈卡片-项目等级图标
 * 接口 projectLevel 不返回时不展示等级图标；返回时是「S级」「A级」这类中文，
 * 直接复用项目已有的中文名映射（XTCLabel），命中才有图标地址，未命中同样不展示。
 */
export function getSimilarLevelImage(projectLevel?: string) {
  return projectLevel ? XTCLabel[projectLevel] || '' : '';
}

/**
 * 相似商圈卡片-相似度标签文案
 * 接口 similarity 是后端四舍五入取整后的整数，无值时不展示该标签。
 */
export function getSimilarityText(similarity?: number) {
  return isNotEmpty(similarity) ? `${similarity}%相似` : '';
}

export function getSimilarMetric(item: any, configSwitch: any = {}) {
  if (isNotEmpty(item?.mallPassFlow)) {
    return { label: '日均客流', value: item.mallPassFlow, unit: '人次' };
  }
  if (configSwitch?.modelIndustry === 1) {
    // 车辆服务指标要求无数据时模块也要展示，这里把空值兜底为 0，
    // 并标记 alwaysShow，避免渲染时被「有值才展示」的判断过滤掉
    return {
      label: '车辆服务',
      value: isNotEmpty(item?.carServiceCount) ? item.carServiceCount : 0,
      unit: '家',
      alwaysShow: true,
    };
  }
  return { label: '500m常住', value: item?.residentPopulation500m, unit: '人' };
}

export function shouldShowSimilarRevenue(item: any) {
  return isNotEmpty(item?.salesAmountPredict);
}

/**
 * 相似商圈卡片-指标模块是否展示
 * 车辆服务（alwaysShow）即使兜底为 0 也要展示；日均客流、500m常住无数据或为 0 时整行不展示。
 * 与移动端保持同一套判断，避免两端显隐规则漂移。
 */
export function shouldShowSimilarMetric(metric: any) {
  if (metric?.alwaysShow) return true;
  return isNotEmpty(metric?.value) && +metric.value !== 0;
}
